<loader></loader>
<toasters></toasters>
<modal-list></modal-list>

<router-outlet></router-outlet>
